<script type="ts">
  import CloseCircle from "svelte-material-icons/CloseCircle.svelte";

  export let player: Player;
  export let onChangeUserIcon = null;
  export let onDeleteUser = null;

  $: isClickable = onChangeUserIcon != null;

  const onClickChip = (_) => {
    onChangeUserIcon(player.id);
  };

  const onClickDelete = (e) => {
    // prevent click through
    e.stopPropagation();
    onDeleteUser(player.id);
  };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="p-4 my-1 ml-1 border-2 border-solid border-base-200 badge bg-base-200  text-base-content {isClickable &&
    'cursor-pointer select-none'} hover:border-[{player.color}]"
  style="border-color: {onChangeUserIcon != null ? player.color : 'none'};"
  on:click={onChangeUserIcon != null ? onClickChip : null}
>
  <div class="mr-2 text-lg">{player.icon}</div>
  <p>{player.name}</p>
  {#if onDeleteUser != null}
    <div class="ml-2 text-red-400 hover:text-red-600" on:click={onClickDelete}>
      <CloseCircle size={20} />
    </div>
  {/if}
</div>

<style>
</style>
